module.exports = __webpack_public_path__ + "public/img/yhj.f3a1e4b3.png";